import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Typography } from '@otp/ui';
import clsx from 'clsx';
import { SUPPORT_EMAIL } from 'src/constants/config';
import { ReactComponent as LeftDecor } from './otp-decor.svg';

export const ContactAdministrator = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4">
      <Card
        className={clsx(
          'bg-[#F8B92A] relative overflow-hidden',
          'flex p-0 w-full h-[217px]',
        )}
      >
        <div className="h-full">
          <LeftDecor />
        </div>

        <div className="flex flex-col w-full justify-center p-6 mx-auto">
          <Typography
            fontWeight="bold"
            className="whitespace-pre-line mb-6"
            variant="h6"
          >
            {t(
              'my-organisation.program-opt-in.errors.no-program-assigned.title',
            )}
          </Typography>
          <Card
            noBorder
            className="bg-[#1C1F21] text-white px-4 py-1.5 inline-flex items-center justify-between rounded-xl w-full min-h-[45px] md:w-[280px]"
            onClick={() => {
              window.open(`mailto:${SUPPORT_EMAIL}`, '_blank');
            }}
          >
            <Typography
              variant="body1"
              className="text-base max-[445px]:text-[10px] leading-none"
            >
              {t(
                'my-organisation.program-opt-in.errors.no-program-assigned.cta',
              )}
            </Typography>
            <span className="text-sm">+</span>
          </Card>
        </div>
      </Card>
    </div>
  );
};
